import { colord as e } from "./index43.mjs";
const p = [
  {
    primaryColor: "--brand-primary",
    colors: [
      { cssVar: "--brand-primary" },
      {
        cssVar: "--brand-primary-hover",
        lightnessMultiplier: 0.86
      },
      {
        cssVar: "--brand-primary-subtle",
        hueDelta: 8,
        saturation: 25,
        lightness: 98
      }
    ]
  },
  {
    primaryColor: "--text-primary",
    colors: [
      { cssVar: "--text-primary" },
      {
        cssVar: "--text-secondary",
        hueDelta: -16,
        saturation: 14,
        lightness: 65
      },
      {
        cssVar: "--text-tertiary",
        hueDelta: -6,
        saturation: 16,
        lightness: 50
      },
      {
        cssVar: "--fill-primary",
        hueDelta: -8,
        saturation: 27,
        lightness: 84
      }
    ]
  },
  {
    primaryColor: "--background-primary",
    colors: [
      { cssVar: "--background-primary" },
      {
        cssVar: "--background-tertiary",
        hueDelta: -4,
        saturation: 16,
        lightness: 93
      },
      {
        cssVar: "--skeleton-primary",
        hueDelta: 19,
        saturation: 8,
        lightness: 81
      }
    ]
  },
  {
    primaryColor: "--background-header",
    colors: [{ cssVar: "--background-header" }]
  }
];
function d(o, l) {
  const t = e(o).toRgb(), a = e(o).toHsl(), i = {};
  return l.colors.forEach((r) => {
    if (r.cssVar === l.primaryColor)
      i[r.cssVar] = `${t.r} ${t.g} ${t.b}`;
    else {
      let s = a.h + (r.hueDelta ?? 0);
      s < 0 && (s += 360), s >= 360 && (s -= 360);
      const u = r.saturation !== void 0 ? Math.round(r.saturation) : a.s, h = r.lightness !== void 0 ? Math.round(r.lightness) : r.lightnessMultiplier ? Math.round(a.l * r.lightnessMultiplier) : a.l, n = e({ h: s, s: u, l: h }).toRgb();
      i[r.cssVar] = `${n.r} ${n.g} ${n.b}`;
    }
  }), i;
}
export {
  d as adjustColorGroup,
  p as semanticColorGroups
};
